type Rows = Array<Array<string | Date | undefined | null>>;

export const downloadCSV = async ({
  filename,
  rows,
}: {
  filename: string;
  rows: Rows;
}) => {
  const { generateCSVFile } = await import('./csv');
  generateCSVFile(filename, rows);
};

export const downloadXLSX = async ({
  filename,
  rows,
}: {
  filename: string;
  rows: Rows;
}) => {
  const { generateXlsFile } = await import('./xlsx');
  generateXlsFile(filename, rows);
};
